/*
 * App Registry Loader (Client)
 * Falls back to UAT defaults if the app registry is missing.
 */

try {
    module.exports = require("../../.includes/uat.registry.client.js");
} catch (error) {
    console.log("App registry (client) not found. Falling back to UAT defaults.", {
        error: error
    });
    module.exports = require("./registry.client.js");
}
